// The shared comms socket bound to the browser. Two things are the browser's:
//
// - How a socket opens: `new WebSocket` against the BFF. The browser attaches
//   the httpOnly session cookie to the upgrade handshake automatically, so
//   there is no token to bake into the URL.
// - What "watched" means: whether the tab is visible. The `visibilitychange`
//   event fires when the user switches tabs, minimises, or comes back, and
//   `document.hidden` says which; each firing is reported to the shared class
//   as `setWatched(!document.hidden)`. The policy behind it — cancel a pending
//   reconnect while hidden, close after five hidden minutes, reopen when
//   visible — lives in the shared class, not here.

import { ChatSocket as BaseChatSocket, type ChatSocketHandlers } from '@d-orca/shared/client/comms';

export type { ChatSocketHandlers };

const BFF_BASE_URL = import.meta.env.VITE_BFF_BASE_URL ?? 'http://localhost:3030';

export class ChatSocket extends BaseChatSocket {
  private readonly visibilityHandler = () => this.setWatched(!document.hidden);

  constructor(siteId: string, handlers: ChatSocketHandlers) {
    super(siteId, handlers, {
      createSocket: (path) => new WebSocket(`${BFF_BASE_URL.replace(/^http/, 'ws')}${path}`),
    });
    document.addEventListener('visibilitychange', this.visibilityHandler);
  }

  override close(): void {
    document.removeEventListener('visibilitychange', this.visibilityHandler);
    super.close();
  }
}
